import { render, staticRenderFns } from "./ShowQRCode.vue?vue&type=template&id=09752e8b&scoped=true&lang=pug&"
import script from "./ShowQRCode.vue?vue&type=script&lang=ts&"
export * from "./ShowQRCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09752e8b",
  null
  
)

export default component.exports